import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PopoverController} from '@ionic/angular';
import {CategorySelectPopoverComponent} from './category-select-popover.component';
import {DeviceTypeItem} from '../../../services/common-datatypes';
import {AutoUnsubscribe, RequiredInput} from '../../../decorators/common.decorators';
import {CommonFunctionsService} from '../../../services/common-functions.service';
import {Subscription} from 'rxjs';
import {StateStorageService} from '../../../services/state-storage.service';
import {skip} from 'rxjs/operators';

@Component({
    selector: 'app-category-select',
    templateUrl: './category-select.component.html',
    styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent implements OnInit, OnDestroy {

    public fullName!: string;
    @Input() translationPrefix = 'search';
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() labelPosition = 'stacked';
    @Input() canUsePartial = false;
    private _selectedCategory: DeviceTypeItem = new DeviceTypeItem();
    @Input() @RequiredInput
    set selectedCategory(category: DeviceTypeItem) {
        if (!category) return;
        this._selectedCategory.updateFromJson(category);
        this.setFullName();
    }

    @Output() selectedCategoryChange = new EventEmitter<DeviceTypeItem>();

    // noinspection JSMismatchedCollectionQueryUpdate
    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    constructor(private appState: StateStorageService,
                private commonFunctions: CommonFunctionsService,
                private popoverCtrl: PopoverController) {
    }

    ngOnInit(): void {
        if (this.autoOpen) this.openDropDown(new Event(''));
        this.setFullName();
    }

    ngOnDestroy(): void {
    }

    public setFullName(): void {
        if (!this._selectedCategory) this.fullName = '';
        else this.fullName = this.commonFunctions.combinedCategoryName(this._selectedCategory, true);
    }

    public async openDropDown(event: Event) {
        this.popoverCtrl.create({
            component: CategorySelectPopoverComponent,
            componentProps: {
                canUsePartial: this.canUsePartial,
                selectedCategory: this._selectedCategory
            },
            event: event,
            cssClass: 'autosize-popover'
        }).then((popover: HTMLIonPopoverElement) => {
            popover.present();
            popover.onDidDismiss().then((returnEvent) => {
                if (undefined !== returnEvent.data) {
                    this._selectedCategory.updateFromJson(returnEvent.data);
                }
                this.setFullName();
                this.selectedCategoryChange.emit(this._selectedCategory);
                //console.log('dismissed ' + returnEvent);
            });
            this.subscriptions.push(this.appState.navigation$.pipe(skip(1))
                .subscribe(() => {
                    popover.dismiss();
                })
            );
        });
    }

    clearCategory(event: Event) {
        if (event) event.stopPropagation();
        this._selectedCategory.reset();
        this.setFullName();
        this.selectedCategoryChange.emit(this._selectedCategory);
    }
}
